import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../axiosConfig";
import TrainerLayout from "./TrainerLayout";
import Tabs from "../commons/Tabs";
import "../../styles/DogDetails.css";
import TrainingSummaryList from "./TrainingSummaryList";
import AssignedExercisesList from "./AssignedExercisesList";
import TrainerNotesList from "./TrainerNotesList";
import DogSurveysList from "./DogSurveysList";
import DogReportsTab from "./DogReportsTab";
import DogInfoTab from "./DogInfoTab"; // Import the new combined component
import { IoArrowBack } from "react-icons/io5"; // Import back arrow icon

const DogDetails = () => {
    const { dogId } = useParams();
    const navigate = useNavigate();
    const [dog, setDog] = useState(null);
    const [owner, setOwner] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchDogDetails = async () => {
            try {
                const token = localStorage.getItem("jwt");

                // Fetch dog details
                const dogResponse = await axios.get(`/api/v1/dog/details/${dogId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const dogData = dogResponse.data;
                setDog(dogData);

                // Fetch owner details if ownerId exists
                if (dogData.ownerId) {
                    const ownerResponse = await axios.get(`/api/v1/owner/details/${dogData.ownerId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    setOwner(ownerResponse.data);
                }
            } catch (err) {
                setError("Nie udało się pobrać danych psa lub właściciela.");
            } finally {
                setLoading(false);
            }
        };

        fetchDogDetails();
    }, [dogId]);

    const handleBackToPodopieczni = () => {
        navigate("/podopieczni");
    };

    if (loading) return <TrainerLayout><p>Ładowanie...</p></TrainerLayout>;
    if (error) return <TrainerLayout><p className="error">{error}</p></TrainerLayout>;

    return (
        <TrainerLayout>
            <div className="dog-details-container">
                {/* Back Arrow Button */}
                <button
                    className="dog-details-back-btn"
                    onClick={handleBackToPodopieczni}
                    aria-label="Wróć do podopiecznych"
                >
                    <IoArrowBack />
                </button>

                <h1 className="dog-name">{dog?.name || "Nieznany Pies"}</h1>

                <Tabs
                    tabs={[
                        {
                            key: "dog_info",
                            label: "Dane Pupila",
                            endpoint: dog ? `/api/v1/dog/details/${dog.id}` : "",
                            paginated: false,
                            renderContent: (data) => <DogInfoTab dog={data} owner={owner} />,
                        },
                        {
                            key: "recommendations",
                            label: "Zalecenia",
                            endpoint: dog ? `/api/v1/training-summary/dog/${dog.id}` : "",
                            paginated: true,
                            renderContent: (data) => <TrainingSummaryList summaries={data} dogId={dogId} />,
                        },
                        {
                            key: "exercises",
                            label: "Ćwiczenia",
                            endpoint: dog ? `/api/v1/exercise/dog/${dog.id}/assigned` : "",
                            paginated: true,
                            renderContent: (data) => <AssignedExercisesList exercises={data} dogId={dogId} />,
                        },
                        {
                            key: "notes",
                            label: "Notatki",
                            endpoint: dog ? `/api/v1/trainer-note/dog/${dog.id}` : "",
                            paginated: true,
                            renderContent: (data) => <TrainerNotesList notes={data} dogId={dogId} />,
                        },
                        {
                            key: "surveys",
                            label: "Ankiety",
                            endpoint: dog ? `/api/v1/survey/dog/${dog.id}/assigned` : "",
                            paginated: false,
                            renderContent: (data) => <DogSurveysList surveys={data} dogId={dogId} />,
                        },
                        {
                            key: "reports",
                            label: "Raporty",
                            endpoint: dog && dog.id ? `/api/v1/reports/dog/${dog.id}/reports` : null,
                            paginated: false,
                            renderContent: (data) => <DogReportsTab dogReports={data || { assignments: [], submissions: [] }} dogId={dogId} />,
                        },
                    ]}
                    activeId={dogId}
                />
            </div>
        </TrainerLayout>
    );
};

export default DogDetails;